import { render } from "./BGM.vue?vue&type=template&id=2d2637df"
import script from "./BGM.vue?vue&type=script&lang=js"
export * from "./BGM.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__